module.exports = require('./helpers/bundle-url').getBundleURL('fSmkK') + "logo.7718c6df.svg";